module.exports = __webpack_public_path__ + "static/img/emoji_151.6db48b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emoji/emoji_151.png
// module id = UgGX
// module chunks = 6